<script setup>
import {computed} from 'vue'
import {useStateHistoryStore} from '@/stores/stateHistory'

const stateHistoryStore = useStateHistoryStore()

// --- Computed ---

const items = computed(() => stateHistoryStore.items)

// --- Methods ---

const open = (fullPath) => {
    // Navigates using the hash-based routing as per original logic
    window.location = '#' + fullPath
}
</script>

<template>
    <div class="dashboard-panel-state-history card">
        <div class="card-header">
            Your viewing history
        </div>

        <div class="card-body small">
            <div
                v-for="(item, index) in items"
                :key="item.id"
                role="button"
                class="breadcrumb"
                :class="{ 'mb-1': index !== items.length - 1 }"
                @click="open(item.fullPath)"
            >
                <template v-if="item.fullPath">
                    <span class="breadcrumb-item">{{ item.componentTitle }}</span>
                    <span v-if="item.itemTitle" class="breadcrumb-item">
                        {{ item.itemTitle }}
                    </span>
                </template>
            </div>
        </div>
    </div>
</template>